'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchProbeList = require('./components/SearchProbeList.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SearchProbeList).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/probes/lib/components/search-probe-list/index.js
// module id = 1455
// module chunks = 1